export interface AuthorsCabinAsset {
  readonly key: string; readonly path: string; readonly width: number; readonly height: number;
  readonly alpha: boolean; readonly required: true;
}
const ROOT = 'assets/story-forest/authors-cabin';
const image = (key: string, path: string, width: number, height: number, alpha: boolean): AuthorsCabinAsset => ({ key, path: `${ROOT}/${path}`, width, height, alpha, required: true });
export const AUTHORS_CABIN_ASSETS = {
  dormant: image('authors-cabin-dormant', 'backgrounds/authors-cabin-dormant.png', 1280, 720, false),
  restored: image('authors-cabin-restored', 'backgrounds/authors-cabin-restored.png', 1280, 720, false),
  authorTool: image('authors-cabin-author-tool', 'interactives/author-tool-medallion.png', 512, 512, true),
} as const;
export const AUTHORS_CABIN_ASSET_LIST = Object.values(AUTHORS_CABIN_ASSETS);
export const AUTHORS_CABIN_PRODUCTION_READY = true;
export function preloadAuthorsCabinAssets(scene: Phaser.Scene) { AUTHORS_CABIN_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path)); }
export function getMissingAuthorsCabinAssets(textures: Phaser.Textures.TextureManager) { return AUTHORS_CABIN_ASSET_LIST.filter(asset => !textures.exists(asset.key)); }
export function canEnterAuthorsCabin(textures: Phaser.Textures.TextureManager) { return AUTHORS_CABIN_PRODUCTION_READY && getMissingAuthorsCabinAssets(textures).length === 0; }
